import type { RegisteredRouter } from '@tanstack/react-router';

export type TanstackUrl =
  RegisteredRouter['routesByPath'][keyof RegisteredRouter['routesByPath']]['fullPath'];

export type Step = {
  id: string;
  name: string;
  hideStepCount?: boolean; // whether to hide `n of m` in the stepper
  description?: string; // renders as `n of m ${description}`
  url: TanstackUrl;
};

export function getNextStepUrl(steps: Step[]): TanstackUrl | undefined {
  const stepIndex = getCurrentStepIndex(steps);
  const nextStep = stepIndex !== -1 ? steps[stepIndex + 1] : null;
  return nextStep ? nextStep.url : undefined;
}

export function getCurrentStepIndex(steps: Step[]): number {
  return steps.findIndex((s) => s.url === window.location.pathname);
}
